import { Toaster } from "../components/ui/sonner";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Process from "../components/Process";
import WhyChooseUs from "../components/WhyChooseUs";
import AppointmentBooking from "../components/AppointmentBooking";
import Projects from "../components/Projects";
import Testimonials from "../components/Testimonials";
import QuoteForm from "../components/QuoteForm";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";

const Home = () => {
  return (
    <div className="App relative">
      <Toaster position="top-right" />
      <Header />
      <Hero />
      <Services />
      <Process />
      <WhyChooseUs />
      <AppointmentBooking />
      <Projects />
      <Testimonials />
      <QuoteForm />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Home;
